import headerBg from '@/assets/images/active/hjwq/mid-autumn/header/header_bg.png';
import headerBg2 from '@/assets/images/active/hjwq/mid-autumn/header/header_bg2.png';
import officeBtn from '@/assets/images/active/hjwq/mid-autumn/header/btn_05.png';
import loginBtn from '@/assets/images/active/hjwq/mid-autumn/header/btn_06.png';
import accountBtn from '@/assets/images/active/hjwq/mid-autumn/header/btn_07.png';
import activeBtn from '@/assets/images/active/hjwq/mid-autumn/header/btn_09.png';
import logoutBtn from '@/assets/images/active/hjwq/mid-autumn/header/btn_10.png';

export const headerConfig = {
  not_logged_in: {
    background_image: headerBg,
    style: ''
  },
  logged_in: {
    background_image: headerBg2,
    main_title_color: '#784434',
    sub_title_color: '#784434',
    tips_color: '#784434',
    game_name: '新仙剑奇侠传之挥剑问情'
  },
  operation_btn: {
    office_website: {
      width: '',
      height: '',
      background_image: '',
      img: officeBtn,
      style: 'top: 0.4rem',
      link: 'https://hjwq.qingcijoy.com/'
    },
    login: {
      width: '',
      height: '',
      background_image: '',
      img: loginBtn,
      style: 'top: 0.4rem'
    },
    change_account: {
      width: '',
      height: '',
      background_image: '',
      img: accountBtn,
      style: 'top: 0.4rem'
    },
    join_active: {
      width: '',
      height: '',
      background_image: '',
      img: activeBtn,
      style: 'top: 0.4rem',
      link: 'https://qcg.ink/A5Pkd'
    },
    logout: {
      width: '',
      height: '',
      img: logoutBtn,
      style: 'top: 0.4rem'
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/hjwq/mid-autumn/headerConfig.js